import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { OpenPaymentInfo } from '../../../entities/open-payment-info.model';
import { Marketdate, MarketdateStatusEnum } from '../../../entities';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService } from 'ng-jhipster';

@Component({
  selector: 'app-evaluation',
  templateUrl: './open-payment-info.component.html',
  styles: []
})

export class OpenPaymentInfoComponent implements OnInit {

  @ViewChild('historyModal') private historyModal;
  loadingIndicator = true;
  openPaymentInfos: Array<OpenPaymentInfo>;
  rows: Array<OpenPaymentInfo>;
  selectedRow: OpenPaymentInfo;
  selectedOpenPayments: Array<OpenPaymentInfo>;
  modalRef: any = null;

  constructor(private jhiLanguageService: JhiLanguageService,
              private apiService: ApiService,
              private router: Router,
              private modalService: NgbModal) {
    this.jhiLanguageService.setLocations(['evaluation']);
  }

  ngOnInit() {
    this.getOpenPaymentInfos();
  }

  getOpenPaymentInfos(): void {
    this.loadingIndicator = true;
    this.apiService.find<OpenPaymentInfo>(OpenPaymentInfo, 'open-payment-infos')
      .subscribe((openPaymentInfos: Array<OpenPaymentInfo>) => {
        this.openPaymentInfos = openPaymentInfos;
        this.rows = this.openPaymentInfos
          .filter((openPaymentInfo: OpenPaymentInfo) => openPaymentInfo.status === 'Open');
        this.loadingIndicator = false;
      }, error => {
        console.log('error finding open payment infos', error);
        this.loadingIndicator = false;
      });
  }

  selectMarketdate(row: OpenPaymentInfo) {
    if (row && row.marketdate) {
      this.loadingIndicator = true;
      this.apiService.findOne<Marketdate>(Marketdate, 'marketdates/' + row.marketdate).subscribe(
        (marketdate: Marketdate) => {
          this.loadingIndicator = false;
          switch (marketdate.status) {
            case MarketdateStatusEnum.Opened:
            case MarketdateStatusEnum.Closed:
              this.router.navigate(['open-accountings/' + row.marketdate]);
              break;
            case MarketdateStatusEnum.Confirmed:
              this.router.navigate(['archive/' + row.marketdate]);
              break;
            default:
              console.log('unhandled marketdate status: ', marketdate);
              break;
          }
      }, error => {
          this.loadingIndicator = false;
          console.log('Error loading marketdate', error);
        });
    }
  }

  repeated(row: OpenPaymentInfo): boolean {
    const otherOpenPaymentsOfMerchant = this.openPaymentInfos
      .filter(opi => opi.merchantNumber === row.merchantNumber && opi.marketday === row.marketday && opi.id !== row.id);
    return otherOpenPaymentsOfMerchant.length > 0;
  }

  showHistory(row: OpenPaymentInfo): void {
    this.selectedRow = row;
    this.selectedOpenPayments = this.openPaymentInfos
      .filter(opi => opi.merchantNumber === row.merchantNumber && opi.marketday === row.marketday)
      .sort((a: OpenPaymentInfo, b: OpenPaymentInfo) => {
        const dateA = new Date(a.evasiveDate);
        const dateB = new Date(b.evasiveDate);
        if ((a.status === 'Open' && b.status !== 'Open') || (dateA > dateB && a.status === b.status)) { return -1; }
        if ((b.status === 'Open' && a.status !== 'Open') || (dateB > dateA && b.status === a.status)) { return 1; }
        return 0;
      });
    this.openModal(this.historyModal, {size: 'm', windowClass: ''});
  }

  openModal(modal: any, options) {
    this.modalRef = this.modalService.open(modal, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/evaluation/components/open-payment-info/open-payment-info.component.ts